// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mXsg","toggleWrap":"styles_toggleWrap__1K-E6","content":"styles_content__1zj5K","selectAreaCode":"styles_selectAreaCode__1_pH8"};